<template>
    <div id="buildingEnter">
        <!-- <div class="fixedIconBox" @click="toEnterForm">
            <span class="titleText">申请入驻</span>
        </div>
        <img src="../../images/combinationEnter/enter_02.jpg" alt="" @click="toEnterForm" />
        <img src="../../images/combinationEnter/enter_03.jpg" alt="" />
        <img src="../../images/combinationEnter/enter_04.jpg" alt="" />
        <div class="longBtnBox">
            <button class="btn-red btn-long btn-shadow" @click="toEnterForm">现已开启10万方空间，申请入驻</button>
        </div> -->
        <div class="fixedIconBox" @click="toEnterForm">
            <span class="titleText">申请入驻</span>
        </div>
        <div class="firstSection">
            <div class="backBtn" @click="back" v-if="!isFromYjj">
                <i class="el-icon-arrow-left"></i> 返回 
            </div>
            <img src="../../images/newImages/bg_shengjizongheti_banner.png" alt="">
            <div class="floatBlock">
                <span class="bold">省级综合体空间入驻机会</span>
                <div class='subtitle'>享受配套政策、金融扶持、产业资源的全方位扶持</div>
            </div>
        </div>
        <div class="textBlock">
            <!-- <p style="text-align: center;">            省级综合体空间入驻机会</p> -->
            <!-- <p style="text-align: left;">享受配套政策、金融扶持、产业资源的全方位扶持</p> -->
            <p class="liangduanduiqi">
                服装综合体2019年将覆盖30万方的产业运营空间,全面一站式对外输出产业创新服务模式,在综合体内形成产业链商业模式闭环,综合体将依托产业互联网平台的创新服务打造设计师群落空间、面辅料中心、综合制样中心、智能生产基地、精品电商中心产品发布厅、信息化运营中心、创业孵化中心、品牌街区、产业服务中心、公共服务中心。
            </p>
            <p class="liangduanduiqi">
                入驻任何空间,都将享受综合体的专项配套政策、产业金融扶持、全套的产业服务。
            </p>
            
        </div>
        <div class="thirdBox">
            <img src="../../images/newImages/img_shengjizongheti.png" alt="">

        </div>
        <div class="bottomImg">
            <img src="../../images/newImages/img_logo_dibu.png" alt="" class="footImg">
        
        </div>
        <div class="lastButtonSection">
            <a href="tel:0571-86221010">
                <button  class="btn-red reverse">
                    
                        <img src="../../images/newImages/but_ic_phone.png" alt="" class="btnIcon">
                        联系我们
                </button>
            </a>
            <button  class="btn-red " @click="toEnterForm">
                <img src="../../images/newImages/but_ic_ruzhu.png" alt="" class="btnIcon">
                入驻综合体
            </button>
        </div>
    </div>
</template>

<script>
    import {
        ajaxCode,
        ajaxLogin
    } from '@/assets/request.js'
    import {
        setCookie,
        phoneReg,
        codeReg,
        filterPhoneNum,
        GetRequest
    } from '@/assets/common.js'

    export default {
        data() {
            return {
                paramObj: {},
                phone: '',
                code: '',
                isFromYjj:'',

            }
        },
        methods: {
            back(){
              this.$router.back()  
            },
            toEnterForm() {
                this.$router.push({
                    name: 'BuildingEnterForm'
                });
            },
            login() {
                let _this = this
                ajaxLogin(_this.phone, _this.code).then(res => {

                    let token = JSON.parse(res.data).token
                    let userId = JSON.parse(res.data).userId
                    console.log(token, userId)
                    sessionStorage.setItem("isLogined", "1")
                    sessionStorage.setItem("token", token)
                    sessionStorage.setItem("userId", userId)
                    setCookie("global_token", token, 10)
                }, (res) => {})
            }
        },
        mounted() {
            this.paramObj = GetRequest()
            console.log(this.paramObj )
            this.phone = this.paramObj.p
            this.code = this.paramObj.c
            if (this.phone && this.code) {
                this.login()
            }
            
            this.isFromYjj=this.code?true:false
            console.log(this.isFromYjj,'是否来自衣加加')

        }
    }
</script>

<style lang="less" scoped="scoped">
    img {
        width: 100%;
    }
    #buildingEnter{
        .firstSection{
            position: relative;
            .floatBlock{position: absolute;font-size: 0.48rem;color:#fff; font-weight: bold;width: 100%; top:2rem; text-align: center;}
            .subtitle{font-size:0.28rem;font-weight: normal;  padding:0.2rem 0.5rem;}
        }
        .textBlock{
           color:#333;font-size: 0.36rem;line-height: 0.68rem; padding:0.8rem 0.43rem;  background: #fff;
        }
        .thirdBox{padding: 0 0.43rem; padding-bottom: 1.2rem; background: #fff;}
        
    }
    
</style>



// WEBPACK FOOTER //
// src/page/introPage/buildingEnter.vue